import { post } from '@/util/request.js';
import type { Export } from '@fibl/zdb-common';


export type RequestKomParams = {
	customColumnHeaders: Export.CreateJobParams["customColumnHeaders"],
	runParams: Export.CreateJobParams["runParams"],
	region?: boolean,
	mix: boolean,
	dateRange?: [string,string],
	classifications?: string[],
}

export async function createRequestKomReport(params: RequestKomParams): Promise<string> {
	let res = await post('oxs/export/requestkomreport', params);
	return res;
}

export async function count(params: RequestKomParams): Promise<number> {
	let res = await post('oxs/export/count', params);
	return res;
}
